import type { DatovkaApiType } from '@gov-nx/api/types/databoxTypes';
import type { Optional } from '@gov-nx/core/types/helpers.types';
import { is } from '@gov-nx/core/types/helpers.types';
import { useBoolean } from '@gov-nx/utils/common/Hooks/useBoolean';
import { useDataBoxCredit } from './useDataBoxCredit';

interface LowCreditPromptProps {
	senderId: Optional<string>;
	recipient: Optional<DatovkaApiType>;
	messagePrice: number;
	onPromptClose: () => void;
}

export const useLowCreditPrompt = ({
	senderId,
	recipient,
	messagePrice,
	onPromptClose,
}: LowCreditPromptProps) => {
	const { credit } = useDataBoxCredit(senderId);
	const isLowCreditPrompt = useBoolean(false);
	const isLowCredit = is(credit) && credit < messagePrice;

	const isOpen =
		isLowCreditPrompt.value &&
		is(recipient) &&
		!recipient?.typSchranky?.startsWith('OVM') &&
		isLowCredit;

	const handleOpen = () => isLowCreditPrompt.setTrue();

	const handleClose = () => {
		isLowCreditPrompt.setFalse();
		onPromptClose();
	};

	return {
		isOpen,
		recipient,
		senderId,
		handleOpen,
		handleClose,
	};
};
